// extracted by mini-css-extract-plugin
export default {"searchSec":"Anaylysischat_searchSec__KpSRl"};